module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/order_product_list_search-c60bd979bb1a66584a682fb8f143e873.png";